(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-sec"] && !Shopify.designMode) return;
  try {
    
  (function(){
    'use strict';

    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var hasIO = 'IntersectionObserver' in window;

    function ease(t){ return 1 - Math.pow(1 - t, 3); }

    function parseTarget(raw){
      if (raw === null || raw === undefined) return 0;
      var digits = String(raw).replace(/[^0-9.-]/g, '');
      if (digits === '' || digits === '-' || digits === '.') return 0;
      var n = parseFloat(digits);
      return isNaN(n) ? 0 : n;
    }

    function format(n, target, plain){
      var isInt = Number.isInteger(target);
      if (isInt){
        var r = Math.round(n);
        return plain ? String(r) : r.toLocaleString();
      }
      return n.toFixed(1);
    }

    function animateCounter(el){
      var target = parseTarget(el.getAttribute('data-aa-target'));
      var prefix = el.getAttribute('data-aa-prefix') || '';
      var suffix = el.getAttribute('data-aa-suffix') || '';
      var dur = parseInt(el.getAttribute('data-aa-duration'), 10) || 1800;
      var plain = el.getAttribute('data-aa-plain') === 'true';

      if (reduced){
        el.textContent = prefix + format(target, target, plain) + suffix;
        return;
      }

      var start = null;
      function step(ts){
        if (start === null) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        el.textContent = prefix + format(target * ease(p), target, plain) + suffix;
        if (p < 1){
          window.requestAnimationFrame(step);
        } else {
          el.textContent = prefix + format(target, target, plain) + suffix;
        }
      }
      window.requestAnimationFrame(step);
    }

    function initReveals(root){
      var els = root.querySelectorAll('[data-aa-reveal]');
      if (!els.length) return;
      if (reduced || !hasIO){
        els.forEach(function(el){ el.classList.add('is-inview'); });
        return;
      }
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if (e.isIntersecting){
            e.target.classList.add('is-inview');
            io.unobserve(e.target);
          }
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });
      els.forEach(function(el){ io.observe(el); });
    }

    function initCounters(root){
      var counters = root.querySelectorAll('[data-aa-counter]');
      if (!counters.length) return;
      if (!hasIO){
        counters.forEach(animateCounter);
        return;
      }
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if (e.isIntersecting){
            animateCounter(e.target);
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.4 });
      counters.forEach(function(el){ io.observe(el); });
    }

    function initSection(root){
      if (!root) return;
      initReveals(root);
      initCounters(root);
    }

    function bootAll(){
      document.querySelectorAll('[data-section-type="about-acoem"]').forEach(initSection);
    }

    if (document.readyState === 'loading'){
      document.addEventListener('DOMContentLoaded', bootAll);
    } else {
      bootAll();
    }

    document.addEventListener('shopify:section:load', function(e){
      if (!e.target) return;
      var sec = e.target.matches && e.target.matches('[data-section-type="about-acoem"]')
        ? e.target
        : e.target.querySelector && e.target.querySelector('[data-section-type="about-acoem"]');
      if (sec) initSection(sec);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dodge-seo"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dodge-seo-section')) {
  class DodgeSeoSection extends HTMLElement {
    #observer = null;

    connectedCallback() {
      const root = this.closest('.dseo') || this;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (reduce || !('IntersectionObserver' in window)) {
        root.classList.add('dseo--no-motion');
        for (const el of this.querySelectorAll('[data-reveal]')) el.classList.add('is-in');
        return;
      }

      this.#observer = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (!entry.isIntersecting) continue;
            entry.target.classList.add('is-in');
            this.#observer.unobserve(entry.target);
          }
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.1 }
      );

      for (const el of this.querySelectorAll('[data-reveal]')) this.#observer.observe(el);
    }

    disconnectedCallback() {
      this.#observer?.disconnect();
    }
  }

  customElements.define('dodge-seo-section', DodgeSeoSection);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-categories"] && !Shopify.designMode) return;
  try {
    
(function () {
  var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isTouch = 'ontouchstart' in window || (navigator.maxTouchPoints || 0) > 0;

  function initReveal(root) {
    if (root.dataset.reveal !== 'true') return;
    var cols = root.querySelectorAll('.fc-col');
    if (!('IntersectionObserver' in window) || prefersReduced) {
      cols.forEach(function (c) { c.dataset.revealed = 'true'; });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.dataset.revealed = 'true';
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    cols.forEach(function (c) { io.observe(c); });
  }

  function initTilt(root) {
    if (root.dataset.effect !== 'tilt' || prefersReduced || isTouch) return;
    var cards = root.querySelectorAll('.fc-card');
    cards.forEach(function (card) {
      if (card.__fcTilt) return;
      card.__fcTilt = true;
      var raf = null;

      function onMove(e) {
        var rect = card.getBoundingClientRect();
        var px = (e.clientX - rect.left) / rect.width;
        var py = (e.clientY - rect.top) / rect.height;
        var x = (px - 0.5) * 2;
        var y = (py - 0.5) * 2;
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          card.style.transform =
            'perspective(800px) rotateY(' + (x * 5).toFixed(2) +
            'deg) rotateX(' + (-y * 5).toFixed(2) + 'deg)';
        });
      }
      function onLeave() {
        if (raf) cancelAnimationFrame(raf);
        card.style.transform = '';
      }

      card.addEventListener('mousemove', onMove);
      card.addEventListener('mouseleave', onLeave);
    });
  }

  function initSection(root) {
    if (!root) return;
    initReveal(root);
    initTilt(root);
  }

  function initAll() {
    document.querySelectorAll('.fc[data-section-id]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify theme editor live updates
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector ? e.target.querySelector('.fc[data-section-id]') : null;
    if (!root && e.target.classList && e.target.classList.contains('fc')) root = e.target;
    if (root) initSection(root);
  });
  document.addEventListener('shopify:section:select', function (e) {
    var root = e.target.querySelector ? e.target.querySelector('.fc[data-section-id]') : null;
    if (root) initSection(root);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      this.querySelector('form')?.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
		constructor() {
			super();
		}

		connectedCallback() {
			this.header = document.querySelector('.shopify-section-header');
			this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
			this.headerBounds = {};
			this.currentScrollTop = 0;
			this.preventReveal = false;
			this.predictiveSearch = this.querySelector('predictive-search');

			this.onScrollHandler = this.onScroll.bind(this);
			this.hideHeaderOnScrollUp = () => this.preventReveal = true;

			this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
			window.addEventListener('scroll', this.onScrollHandler, false);

			this.createObserver();

			if (this.headerIsAlwaysSticky) this.reveal;
		}

		disconnectedCallback() {
			this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
			window.removeEventListener('scroll', this.onScrollHandler);
		}

		createObserver() {
			let observer = new IntersectionObserver((entries, observer) => {
			this.headerBounds = entries[0].intersectionRect;
				observer.disconnect();
			});

			if (this.header) {
				observer.observe(this.header);
			}
		}

		onScroll() {
			const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

			if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 1) {
				this.header.classList.add('shopify-section-header-sticky','shopify-section-header-always-sticky');
			};

			if (this.headerIsAlwaysSticky && scrollTop < this.header.offsetHeight) {
				this.header.classList.remove('shopify-section-header-sticky');
			};

			if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
				if (this.predictiveSearch && this.predictiveSearch.onFocusOut) {
					this.predictiveSearch.onFocusOut();
					this.predictiveSearch.onBlur();
				}
				if (this.preventHide) return;
				requestAnimationFrame(this.hide.bind(this));
			} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
				if (!this.preventReveal) {
					requestAnimationFrame(this.reveal.bind(this));
				} else {
					window.clearTimeout(this.isScrolling);

					this.isScrolling = setTimeout(() => {
					this.preventReveal = false;
				}, 66);

				requestAnimationFrame(this.hide.bind(this));
				}
			} else if (scrollTop <= this.headerBounds.top) {
				requestAnimationFrame(this.reset.bind(this));
			}

			this.currentScrollTop = scrollTop;
		}

		hide() {
			if (this.headerIsAlwaysSticky) return;
			this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
			this.closeMenuDisclosure();
		}

		reveal() {
			if (this.headerIsAlwaysSticky) return;
			this.header.classList.add('shopify-section-header-sticky', 'animate');
			this.header.classList.remove('shopify-section-header-hidden');
		}

		reset() {
			if (this.headerIsAlwaysSticky) return;
			this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
		}

		closeMenuDisclosure() {
			this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
			if (this.disclosures) {
				this.disclosures.forEach(disclosure => disclosure.close());
			}
		}
	}

	customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["industries-served"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('industries-rail')) return;

    class IndustriesRail extends HTMLElement {
      #ticking = false;
      #observer = null;

      connectedCallback() {
        this.rail = this.querySelector('[data-rail]');
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        if (!this.rail) return;

        this.rail.addEventListener('scroll', this.#onScroll, { passive: true });
        this.#observer = new ResizeObserver(this.#update);
        this.#observer.observe(this.rail);

        if (this.prev && this.next) {
          this.prev.hidden = false;
          this.next.hidden = false;
          this.prev.addEventListener('click', () => this.#page(-1));
          this.next.addEventListener('click', () => this.#page(1));
        }

        if (window.Shopify?.designMode) {
          document.addEventListener('shopify:block:select', this.#onBlockSelect);
        }

        this.#update();
      }

      disconnectedCallback() {
        this.#observer?.disconnect();
        document.removeEventListener('shopify:block:select', this.#onBlockSelect);
      }

      /** @param {1 | -1} direction */
      #page(direction) {
        const rtl = getComputedStyle(this).direction === 'rtl' ? -1 : 1;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.rail.scrollBy({
          left: direction * rtl * this.rail.clientWidth * 0.8,
          behavior: reduce ? 'auto' : 'smooth',
        });
      }

      #onScroll = () => {
        if (this.#ticking) return;
        this.#ticking = true;
        requestAnimationFrame(() => {
          this.#ticking = false;
          this.#update();
        });
      };

      #update = () => {
        const max = this.rail.scrollWidth - this.rail.clientWidth;
        const position = Math.abs(this.rail.scrollLeft);
        this.toggleAttribute('data-scrollable', max > 1);
        if (!this.prev || !this.next) return;
        this.prev.disabled = position <= 1;
        this.next.disabled = position >= max - 1;
      };

      #onBlockSelect = (event) => {
        if (!this.contains(event.target)) return;
        event.target.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
      };
    }

    customElements.define('industries-rail', IndustriesRail);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["key-features"] && !Shopify.designMode) return;
  try {
    
  class KeyFeatures extends HTMLElement {
    constructor() {
      super();
      this.list = this.querySelector('.key-features__list');
      this.toggle = this.querySelector('.key-features__toggle--button');
      this.showMoreText = this.querySelector('.key-features__show-more');
      this.showLessText = this.querySelector('.key-features__show-less');
      this.initialCount = parseInt(this.list?.dataset.initialCount) || 3;
      this.isExpanded = false;
      this.features = Array.from(this.list?.querySelectorAll('.key-features__feature') || []);
      if (this.toggle) {
        this.hideExtraFeatures();
        this.toggle.addEventListener('click', () => this.toggleFeatures());
      }

      // Freeze the staggered entrance after first paint completes
      const sectionEl = this.closest('[id^="key-features-"]');
      if (sectionEl) {
        setTimeout(() => sectionEl.setAttribute('data-kf-animated', 'done'), 1200);
      }
    }

    hideExtraFeatures() {
      this.features.forEach((feature, index) => {
        feature.style.display = (index < this.initialCount) ? 'list-item' : 'none';
        feature.classList.remove('kf-revealed');
      });
      if (this.toggle) this.toggle.setAttribute('data-kf-expanded', 'false');
    }

    toggleFeatures() {
      if (this.isExpanded) {
        this.hideExtraFeatures();
        if (this.showMoreText) this.showMoreText.style.display = 'inline';
        if (this.showLessText) this.showLessText.style.display = 'none';
      } else {
        this.features.forEach((feature, index) => {
          feature.style.display = 'list-item';
          if (index >= this.initialCount) {
            // Stagger fresh entrance for newly-revealed items
            feature.classList.remove('kf-revealed');
            // Force reflow so the animation replays
            void feature.offsetWidth;
            feature.style.animationDelay = ((index - this.initialCount) * 60) + 'ms';
            feature.classList.add('kf-revealed');
          }
        });
        if (this.showMoreText) this.showMoreText.style.display = 'none';
        if (this.showLessText) this.showLessText.style.display = 'inline';
        if (this.toggle) this.toggle.setAttribute('data-kf-expanded', 'true');
      }
      this.isExpanded = !this.isExpanded;
    }
  }

  customElements.define('key-features', KeyFeatures);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300)
      );
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMediaContent &&
        activeMediaContent.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  class RelatedProduct extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const related = html.querySelector('.related-product');
            if (related && related.innerHTML.trim().length) {
              this.innerHTML = related.innerHTML;
            }

            /* Toggle content */
            $('.product-description-more').click(function (e) {
              e.preventDefault();
              $(this).closest('.product-description-short').next().show();
              $(this).closest('.product-description-short').hide();
            });

            $('.product-description-less').click(function (e) {
              e.preventDefault();
              $(this).closest('.product-description-full').prev().show();
              $(this).closest('.product-description-full').hide();
            });
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }
  }

  class RelatedSlider extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const relatedSlider = html.querySelector(`related-slider[data-id="${this.getAttribute('data-id')}"]`);
            if (relatedSlider && relatedSlider.innerHTML.trim().length) {
              this.innerHTML = relatedSlider.innerHTML;
            }

            /* Related products slider */
            const slider = this.querySelector('.related-slider__list');
            const prevBtn = this.querySelector('.related-slider__button-prev');
            const nextBtn = this.querySelector('.related-slider__button-next');
            const twoColumns = this.querySelector('.swiper-wrapper-2-mobile');
            if (twoColumns && document.querySelector('.related-slider__list')) {
              const productSlider = new Swiper(slider, {
                slidesPerView: 2,
                spaceBetween: 10,
                navigation: {
                  nextEl: nextBtn,
                  prevEl: prevBtn,
                },
                breakpoints: {
                  750: {
                    slidesPerView: 2,
                  },
                  1200: {
                    slidesPerView: 3,
                  },
                },
              });
            } else if (document.querySelector('.related-slider__list')) {
              const productSlider = new Swiper(slider, {
                slidesPerView: 1,
                spaceBetween: 10,
                navigation: {
                  nextEl: nextBtn,
                  prevEl: prevBtn,
                },
                breakpoints: {
                  750: {
                    slidesPerView: 2,
                  },
                  1200: {
                    slidesPerView: 3,
                  },
                },
              });
            }

            /* Color swatches */
            const generateSrcset = (image, widths = []) => {
              const imageUrl = new URL(image['src']);
              return widths
                .filter((width) => width <= image['width'])
                .map((width) => {
                  imageUrl.searchParams.set('width', width.toString());
                  return `${imageUrl.href} ${width}w`;
                })
                .join(', ');
            };

            const createImageElement = (image, classes, sizes, productTitle) => {
              const previewImage = image['preview_image'];
              const newImage = new Image(previewImage['width'], previewImage['height']);
              newImage.className = classes;
              newImage.alt = image['alt'] || productTitle;
              newImage.sizes = sizes;
              newImage.src = previewImage['src'];
              newImage.srcset = generateSrcset(previewImage, [165, 360, 533, 720, 940, 1066]);
              newImage.loading = 'lazy';
              return newImage;
            };

            const checkSwatches = () => {
              document.querySelectorAll('.js-color-swatches-wrapper').forEach((wrapper) => {
                wrapper.querySelectorAll('.js-color-swatches input').forEach((input) => {
                  input.addEventListener('click', (event) => {
                    const primaryImage = wrapper.querySelector('.media--first');
                    const secondaryImage = wrapper.querySelector('.media--second');
                    const handleProduct = wrapper.dataset.product;

                    if (event.currentTarget.checked && primaryImage) {
                      wrapper
                        .querySelector('.js-color-swatches-link')
                        .setAttribute('href', event.currentTarget.dataset.variantLink);
                      if (wrapper.querySelector('.card__add-to-cart button[name="add"]')) {
                        wrapper
                          .querySelector('.card__add-to-cart button[name="add"]')
                          .setAttribute('aria-disabled', false);
                        wrapper
                          .querySelector('.card__add-to-cart button[name="add"] > span')
                          .classList.remove('hidden');
                        wrapper
                          .querySelector('.card__add-to-cart button[name="add"] .sold-out-message')
                          .classList.add('hidden');
                        wrapper.querySelector('.card__add-to-cart input[name="id"]').value =
                          event.currentTarget.dataset.variantId;
                      }

                      const currentColor = event.currentTarget.value;

                      jQuery.getJSON(window.Shopify.routes.root + `products/${handleProduct}.js`, function (product) {
                        const variant = product.variants.filter(
                          (item) => item.featured_media != null && item.options.includes(currentColor)
                        )[0];

                        if (variant) {
                          const newPrimaryImage = createImageElement(
                            variant['featured_media'],
                            primaryImage.className,
                            primaryImage.sizes,
                            product.title
                          );

                          if (newPrimaryImage.src !== primaryImage.src) {
                            let flag = false;
                            if (secondaryImage) {
                              const secondaryImagePathname = new URL(secondaryImage.src).pathname;
                              const newPrimaryImagePathname = new URL(newPrimaryImage.src).pathname;

                              if (secondaryImagePathname == newPrimaryImagePathname) {
                                primaryImage.remove();
                                secondaryImage.classList.remove('media--second');
                                secondaryImage.classList.add('media--first');
                                flag = true;
                              }
                            }
                            if (flag == false) {
                              primaryImage.animate(
                                { opacity: [1, 0] },
                                { duration: 200, easing: 'ease-in', fill: 'forwards' }
                              ).finished;
                              setTimeout(function () {
                                primaryImage.replaceWith(newPrimaryImage);
                                newPrimaryImage.animate({ opacity: [0, 1] }, { duration: 200, easing: 'ease-in' });
                                if (secondaryImage) {
                                  secondaryImage.remove();
                                }
                              }, 200);
                            }
                          }
                        }
                      });
                    }
                  });
                });
              });
            };

            checkSwatches();
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), {
        rootMargin: '0px 0px 200px 0px',
      }).observe(this);
    }
  }

  customElements.define('product-modal', ProductModal);
  customElements.define('related-product', RelatedProduct);
  customElements.define('related-slider', RelatedSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nachi-brand"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('nachi-brand')) return;

    /**
     * The brand section has no behaviour of its own (DESIGN_SPEC_V2 7.3: hover motion only, nothing enters);
     * the element exists so the section follows the one-component-per-section rule and marks itself as enhanced.
     */
    class NachiBrand extends HTMLElement {
      connectedCallback() {
        this.classList.add('is-enhanced');
      }

      disconnectedCallback() {
        this.classList.remove('is-enhanced');
      }
    }

    customElements.define('nachi-brand', NachiBrand);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nachi-company"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('nachi-company')) return;

    /**
     * nachi-company: marks the root enhanced and drives motion #11 (DESIGN_SPEC_V2 5.3): one
     * IntersectionObserver adds is-in to the timeline when 30% of it is visible, then disconnects.
     * CSS draws the rail and pops the dots; without IntersectionObserver the class is added at once.
     * The observer is a plain instance property (not a #private field): Shopify's minifier targets
     * es2017 and lowers private fields with WeakMap helpers, which doubled the 9.1 byte count.
     * Everything is undone in disconnectedCallback for the theme editor's section reload.
     */
    class NachiCompany extends HTMLElement {
      connectedCallback() {
        this.classList.add('is-enhanced');
        const rail = this.querySelector('.nachi-timeline');
        if (!rail) return;
        if (!('IntersectionObserver' in window)) {
          rail.classList.add('is-in');
          return;
        }
        this.io = new IntersectionObserver(
          (entries) => {
            for (const entry of entries) {
              if (!entry.isIntersecting) continue;
              entry.target.classList.add('is-in');
              this.stop();
            }
          },
          { threshold: 0.3 }
        );
        this.io.observe(rail);
      }

      disconnectedCallback() {
        this.stop();
        this.classList.remove('is-enhanced');
      }

      stop() {
        if (this.io) this.io.disconnect();
        this.io = null;
      }
    }

    customElements.define('nachi-company', NachiCompany);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nachi-cta"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // 7.8 / 5.3 motion #10: one IntersectionObserver draws the eyebrow rule in when the block enters (threshold .2),
    // once; nothing else is scripted. Without JS, or under reduced motion, the rule is simply there (nachi-base).
    if (customElements.get('nachi-cta')) return;

    customElements.define('nachi-cta', class extends HTMLElement {
      connectedCallback() {
        var el = this.querySelector('.nachi-eyebrow');
        if (!el || !self.IntersectionObserver) return;
        var io = (this._io = new IntersectionObserver(function (es) {
          // one target: the last entry carries its latest state
          if (es[es.length - 1].isIntersecting) {
            el.classList.add('nachi-eyebrow--draw');
            io.disconnect();
          }
        }, { threshold: 0.2 }));
        io.observe(this.querySelector('.nachi-block') || this);
      }

      disconnectedCallback() {
        if (this._io) this._io.disconnect();
        this._io = null;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nachi-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('nachi-faq')) return;

    /**
     * The FAQ is complete without JavaScript (native details/summary; the open rise is CSS on [open]).
     * This element adds two things: theme-editor support (selecting a question block in the editor
     * sidebar opens that item so the merchant can see the answer they are editing; deselecting closes
     * it again) and the replay of motion #22. Chromium keeps a closed answer's finished nachi-rise
     * animation alive (the closed content is display-locked, so its style is never recomputed), so on
     * every open the answer's animations are rewound to 0 through the Web Animations API: no style
     * write, no layout read. Under reduced motion nachi-base removes the animation, so nothing rewinds.
     */
    class NachiFaq extends HTMLElement {
      connectedCallback() {
        this.ac = new AbortController();
        const signal = this.ac.signal;
        this.classList.add('is-enhanced');
        this.addEventListener('toggle', (event) => this.onToggle(event), { capture: true, signal });
        for (const name of ['select', 'deselect']) {
          document.addEventListener(`shopify:block:${name}`, (event) => this.onSelect(event, name === 'select'), { signal });
        }
      }

      disconnectedCallback() {
        this.ac.abort();
      }

      /**
       * toggle does not bubble, so it is captured; a toggle from anything but an opening details
       * (a closing one, or a popover) has no truthy `open` and returns.
       * @param {Event} event
       */
      onToggle(event) {
        const item = event.target;
        if (!item.open) return;
        const answer = item.querySelector('.nachi-faq__answer');
        if (answer) for (const animation of answer.getAnimations()) animation.currentTime = 0;
      }

      /**
       * Editor select opens the block's item and marks it; deselect closes only an item it opened.
       * @param {Event} event
       * @param {boolean} open
       */
      onSelect(event, open) {
        const target = event.target;
        const item = target instanceof Element && this.contains(target) ? target.closest('details') : null;
        if (!item || (open ? item.open : !item.hasAttribute('data-nachi-editor-opened'))) return;
        item.open = open;
        item.toggleAttribute('data-nachi-editor-opened', open);
      }
    }

    customElements.define('nachi-faq', NachiFaq);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nachi-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('nachi-hero')) return;

    const CLOSE_GRACE_MS = 60;

    class NachiHero extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.rows = [];
        this.pinned = null;
        this.closeTimer = 0;
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        const { signal } = this.controller;
        this.setupStrip(signal);
        this.refreshTitleBlock();

        // Without this class the strip is static, the sky is still and every detail row stays as authored.
        this.classList.add('is-enhanced');
      }

      disconnectedCallback() {
        if (this.controller) this.controller.abort();
        if (this.rowsController) this.rowsController.abort();
        if (this.observer) this.observer.disconnect();
        window.clearTimeout(this.closeTimer);
        this.observer = null;
        this.rows = [];
        this.pinned = null;
      }

      // 6.26 / 6.27 the visible pause control (motion #27) and the off-screen pause (5.2 rule 4). Both the ticker
      // track and the sky layers read the two classes; the state is not persisted.
      setupStrip(signal) {
        const block = this.querySelector('.nachi-block--hero');
        const pause = this.querySelector('.nachi-ticker__pause');
        if (!block || !pause) return;

        pause.addEventListener('click', () => {
          const paused = block.classList.toggle('is-paused');
          pause.setAttribute('aria-pressed', paused ? 'true' : 'false');
        }, { signal });

        if (!('IntersectionObserver' in window)) return;
        this.observer = new IntersectionObserver((entries) => {
          const entry = entries[entries.length - 1];
          this.classList.toggle('is-offscreen', !entry.isIntersecting);
        });
        this.observer.observe(block);
      }

      // The bearing finder (assets/nachi-finder.js) redraws the rows as the visitor types and calls this to bind
      // the new rows; the rows' listeners have their own controller so the old ones go with them.
      refreshTitleBlock() {
        if (this.rowsController) this.rowsController.abort();
        this.rowsController = new AbortController();
        window.clearTimeout(this.closeTimer);
        this.rows = [];
        this.pinned = null;
        this.setupTitleBlock(this.rowsController.signal);
      }

      setupTitleBlock(signal) {
        const block = this.querySelector('.nachi-hero__title-block');
        if (!block) return;

        // 6.0 / WCAG 2.5.8 one control per row: the label's text is wrapped in a button (the span keeps its id and
        // its fade) that discloses the row's reading; Enter / Space click it and the click reaches the row's
        // handler. The row and its segment (a plain span) are pointer conveniences: hover opens, click pins.
        // The readings share one slot of fixed height under the rows (CSS), so opening one never resizes the
        // card; a closed reading is visibility: hidden, so assistive technology meets only the open one.
        for (const dim of block.querySelectorAll('.nachi-hero__dim')) {
          const index = dim.dataset.nachiDim;
          const detail = block.querySelector(`[data-nachi-detail="${index}"]`);
          const segment = block.querySelector(`[data-nachi-seg="${index}"]`);
          const label = dim.querySelector('.nachi-hero__dimlabel');
          let button = null;
          if (detail && label) {
            detail.setAttribute('role', 'note');
            button = label.querySelector('button');
            if (!button) {
              button = document.createElement('button');
              button.type = 'button';
              button.append(...label.childNodes);
              label.append(button);
            }
            button.setAttribute('aria-expanded', 'false');
            button.setAttribute('aria-controls', detail.id);
          }
          this.rows.push({ index, dim, detail, segment, button });

          for (const target of segment ? [dim, segment] : [dim]) {
            target.addEventListener('pointerenter', () => this.open(index, false), { signal });
            target.addEventListener('pointerleave', () => this.scheduleClose(index), { signal });
            target.addEventListener('click', () => this.toggle(index), { signal });
          }
        }

        block.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape') return;
          const row = this.rows.find((candidate) => candidate.dim.hasAttribute('data-nachi-open'));
          if (!row) return;
          event.preventDefault();
          this.close(row.index);
        }, { signal });

        // Theme editor: selecting a segment block opens its row so the merchant sees the detail they are editing.
        document.addEventListener('shopify:block:select', (event) => {
          const blockId = event.detail && event.detail.blockId;
          if (!blockId) return;
          const row = this.rows.find((candidate) => candidate.dim.dataset.nachiBlock === blockId);
          if (row) this.open(row.index, true);
        }, { signal });
      }

      rowFor(index) {
        return this.rows.find((row) => row.index === index) || null;
      }


      open(index, pin) {
        window.clearTimeout(this.closeTimer);
        for (const row of this.rows) {
          const isTarget = row.index === index;
          row.dim.toggleAttribute('data-nachi-open', isTarget);
          if (row.detail) row.detail.toggleAttribute('data-nachi-open', isTarget);
          if (row.segment) row.segment.toggleAttribute('data-nachi-open', isTarget);
          if (row.button) row.button.setAttribute('aria-expanded', isTarget ? 'true' : 'false');
        }
        if (pin) {
          this.pinned = index;
        } else if (this.pinned !== null && this.pinned !== index) {
          this.pinned = null;
        }
      }

      close(index) {
        window.clearTimeout(this.closeTimer);
        const row = this.rowFor(index);
        if (!row) return;
        row.dim.removeAttribute('data-nachi-open');
        if (row.detail) row.detail.removeAttribute('data-nachi-open');
        if (row.segment) row.segment.removeAttribute('data-nachi-open');
        if (row.button) row.button.setAttribute('aria-expanded', 'false');
        if (this.pinned === index) this.pinned = null;
      }

      scheduleClose(index) {
        if (this.pinned === index) return;
        window.clearTimeout(this.closeTimer);
        if (this.reduceMotion) {
          this.close(index);
          return;
        }
        // A short grace so moving from a segment down to its own row does not flicker it.
        this.closeTimer = window.setTimeout(() => {
          if (this.pinned !== index) this.close(index);
        }, CLOSE_GRACE_MS);
      }

      toggle(index) {
        const row = this.rowFor(index);
        if (!row) return;
        if (this.pinned === index) {
          this.close(index);
          return;
        }
        this.open(index, true);
      }
    }

    customElements.define('nachi-hero', NachiHero);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nachi-library"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    if (customElements.get('nachi-library')) return;

    /**
     * Document library: category filter and search as progressive enhancements (DESIGN_SPEC_V2 7.5).
     * Cards are server-rendered links; this element only hides non-matching ones and keeps the
     * polite live region current. Strings come from the root's data attributes, never from markup.
     * One IntersectionObserver draws the block title's rule in once the header enters (motion #10).
     */
    class NachiLibrary extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.timer = 0;
        this.grid = this.querySelector('[data-nachi-grid]');
        this.filter = this.querySelector('[data-nachi-filter]');
        this.search = this.querySelector('[data-nachi-search]');
        this.status = this.querySelector('[data-nachi-status]');
        this.empty = this.querySelector('[data-nachi-empty]');
        this.emptyText = this.querySelector('[data-nachi-empty-text]');
        this.clear = this.querySelector('[data-nachi-clear]');
        this.items = Array.from(this.querySelectorAll('[data-nachi-item]'));
        this.missing = Array.from(this.querySelectorAll('[data-nachi-missing]'));

        this.watch();

        if (!this.grid || !this.filter || !this.search) return;

        const { signal } = this.controller;
        this.classList.add('is-enhanced');

        this.filter.addEventListener('change', () => this.apply(), { signal });
        this.search.addEventListener(
          'input',
          () => {
            clearTimeout(this.timer);
            this.timer = setTimeout(() => this.apply(), 120);
          },
          { signal }
        );
        this.search.addEventListener('search', () => this.apply(), { signal });
        if (this.clear) this.clear.addEventListener('click', () => this.reset(), { signal });

        // Theme editor: selecting a document block the filter or search has hidden shows every card again,
        // so the editor can scroll to and outline it (block events bubble up from the <li>).
        this.addEventListener(
          'shopify:block:select',
          (event) => {
            const item = event.target instanceof Element ? event.target.closest('[data-nachi-item], [data-nachi-missing]') : null;
            if (item && item.hidden) this.reset(false);
          },
          { signal }
        );

        this.apply(false);
      }

      disconnectedCallback() {
        if (this.controller) this.controller.abort();
        if (this.io) this.io.disconnect();
        clearTimeout(this.timer);
        this.classList.remove('is-enhanced', 'is-in');
      }

      /** Motion #10: one-shot observer on the block header; `is-in` plays the rule draw in CSS. */
      watch() {
        const header = this.querySelector('[data-nachi-header]');
        if (!header || !('IntersectionObserver' in window)) {
          this.classList.add('is-in');
          return;
        }
        this.io = new IntersectionObserver(
          (entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            this.classList.add('is-in');
            this.io.disconnect();
          },
          { threshold: 0.2 }
        );
        this.io.observe(header);
      }

      /** @returns {Object} the checked chip as { value, label } */
      get category() {
        const checked = this.filter.querySelector('input:checked');
        if (!checked) return { value: 'all', label: this.dataset.nachiAllLabel || '' };
        return { value: checked.value, label: checked.dataset.nachiLabel || '' };
      }

      /**
       * Show the matching cards, hide the rest, and describe the result.
       * @param {boolean} [announce=true] write the sentence to the live region
       */
      apply(announce = true) {
        const category = this.category;
        const query = this.search.value.trim().toLowerCase();
        const filtering = category.value !== 'all' || query !== '';
        let count = 0;

        for (const item of this.items) {
          const inCategory = category.value === 'all' || item.dataset.nachiCategory === category.value;
          const inQuery = query === '' || (item.dataset.nachiIndex || '').includes(query);
          const show = inCategory && inQuery;
          item.hidden = !show;
          if (show) count += 1;
        }
        for (const item of this.missing) item.hidden = filtering;

        const message = count === 0 ? this.emptyMessage(category, query) : this.countMessage(count, category);
        this.grid.hidden = count === 0;
        if (this.empty) this.empty.hidden = count !== 0;
        if (this.emptyText && count === 0) this.emptyText.textContent = message;
        // 7.5 zero matches: the empty card carries the visible sentence, so the readout is visually hidden
        // (nachi-base utility) and only announces it; with matches the readout is the visible count line again.
        if (this.status) this.status.classList.toggle('nachi-visually-hidden', count === 0);
        if (announce) this.announce(message);
      }

      /**
       * @param {string} pattern a setting string with {count}, {category} or {query} tokens
       * @param {Record<string, string | number>} values
       * @returns {string}
       */
      fill(pattern, values) {
        let out = pattern;
        for (const [key, value] of Object.entries(values)) {
          out = out.split('{' + key + '}').join(String(value));
        }
        return out;
      }

      countMessage(count, category) {
        const data = this.dataset;
        if (category.value !== 'all' && data.nachiPatternFiltered) {
          return this.fill(data.nachiPatternFiltered, { count, category: category.label });
        }
        if (count === 1 && data.nachiPatternOne) return this.fill(data.nachiPatternOne, { count });
        return this.fill(data.nachiPattern || '', { count });
      }

      emptyMessage(category, query) {
        const data = this.dataset;
        let pattern = query === '' ? data.nachiEmptyNoQuery || '' : data.nachiEmpty || '';
        if (category.value === 'all') pattern = pattern.replace(/\s+in\s+\{category\}/, '');
        return this.fill(pattern, { query, category: category.label || data.nachiAllLabel || '' });
      }

      /** Clear-then-set so repeated identical sentences are still announced. */
      announce(message) {
        if (!this.status) return;
        this.status.textContent = '';
        requestAnimationFrame(() => {
          if (this.isConnected) this.status.textContent = message;
        });
      }

      /**
       * "Clear filters": back to All, empty query, focus returns to the search input (no smooth scroll: 5.4).
       * @param {boolean} [refocus=true] false when the theme editor is about to scroll to a block itself
       */
      reset(refocus = true) {
        const all = this.filter.querySelector('input[value="all"]');
        if (all) all.checked = true;
        this.search.value = '';
        this.apply();
        if (!refocus) return;
        this.search.focus({ preventScroll: true });
        this.search.scrollIntoView({ behavior: 'auto', block: 'nearest' });
      }
    }

    customElements.define('nachi-library', NachiLibrary);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nachi-model"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (typeof window === 'undefined' || !('customElements' in window)) return;
    if (customElements.get('nachi-model')) return;

    var LIB = 'https://cdn.jsdelivr.net/npm/@google/model-viewer@4/dist/model-viewer.min.js';
    var SWING_CAP = 1300;
    var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
    var lib = null;
    var failed = false;

    function webgl() {
      try {
        var c = document.createElement('canvas');
        return !!(c.getContext('webgl2') || c.getContext('webgl'));
      } catch (e) {
        return false;
      }
    }

    /* 9.3: one module request per page however many stages ask; the data-nachi-mv guard and fetchpriority low are the spec's */
    function loadLib() {
      if (customElements.get('model-viewer')) return Promise.resolve();
      if (lib) return lib;
      lib = new Promise((ok, no) => {
        var s = document.querySelector('script[data-nachi-mv]');
        if (!s) {
          s = document.createElement('script');
          s.type = 'module';
          /* a URL that failed is memoised as failed in the module map, so a retry (a later instance, an editor re-render) needs a fresh one */
          s.src = LIB + (failed ? '?r=' + Date.now() : '');
          s.setAttribute('fetchpriority', 'low');
          s.setAttribute('data-nachi-mv', '');
          document.head.appendChild(s);
        }
        s.addEventListener('error', () => {
          s.remove();
          lib = null;
          failed = true;
          no(new Error('model-viewer'));
        }, { once: true });
        customElements.whenDefined('model-viewer').then(ok, no);
      });
      return lib;
    }

    /* "35deg 65deg 100%" -> { t, p } in radians, or null */
    function orbit(v) {
      var parts = String(v || '').trim().split(/\s+/);
      if (parts.length < 2) return null;
      var out = [];
      for (var i = 0; i < 2; i += 1) {
        var m = /^(-?\d*\.?\d+)(deg|rad)?$/.exec(parts[i]);
        if (!m) return null;
        out.push(m[2] === 'rad' ? +m[1] : (+m[1] * Math.PI) / 180);
      }
      return { t: out[0], p: out[1] };
    }

    function dist(a, b) {
      var d = Math.abs(a - b) % (Math.PI * 2);
      return d > Math.PI ? Math.PI * 2 - d : d;
    }

    function on(el, map, signal) {
      for (var k in map) el.addEventListener(k, map[k], { signal: signal });
    }

    function mark(el, attr, set) {
      if (!el) return;
      if (set) el.setAttribute(attr, '');
      else el.removeAttribute(attr);
    }

    /* Short private names on purpose: the body ships inside the store's one scripts.js and the model's 8 KB cap is the tightest (9.1).
       v viewer, st stage, rb rotate chip, xb reset chip, lb load button, lv live region, ln loading note, fn fallback note,
       rs legend rows, bs balloons, o0 / o1 orbits (two angles), r camera distance; flags: ld loaded, iv in view, sw swung,
       rv revealed, off off-screen, ak library asked, rm reduced motion, ed theme editor, pz paused by the visitor.
       Model variants: vs chips, cur pressed chip, key its label for show_on, dt / se spec card designation / Seals value,
       sh announcement word, an announce on the next load, er an error is showing, pd snap pending, sq the running snap. */
    class NachiModel extends HTMLElement {
      connectedCallback() {
        this.ac = new AbortController();
        var sg = this.sg = this.ac.signal;
        this.tm = [];
        this.io = this.near = null;
        this.ld = this.iv = this.sw = this.rv = this.off = this.ak = false;
        this.rm = !!(reduce && reduce.matches);
        /* theme editor: no swing, no turntable, so a placement can be judged where it sits */
        this.ed = !!(window.Shopify && window.Shopify.designMode);
        this.pz = this.rm || this.ed;
        this.classList.add('is-enhanced');

        var q = (s) => this.querySelector(s);
        this.v = q('[data-nachi-viewer]');
        this.st = q('[data-nachi-stage]');
        this.rb = q('[data-nachi-control="rotate"]');
        this.xb = q('[data-nachi-control="reset"]');
        this.lb = q('[data-nachi-load]');
        this.lv = q('[data-nachi-live]');
        this.ln = q('[data-nachi-loading]');
        this.fn = q('[data-nachi-fallback]');
        this.rs = Array.from(this.querySelectorAll('[data-nachi-row]'));
        this.bs = Array.from(this.querySelectorAll('[data-nachi-balloon]'));
        /* spec rows with a show_on list (the other rows are on every model) */
        this.sp = Array.from(this.querySelectorAll('.nachi-model__spec-row[data-nachi-on]'));
        /* model variants: vs the enabled chips, cur the pressed one, key its label (lower case) for the hotspots' show_on,
           dt / se the spec card's designation and Seals value, sh the announcement's first word */
        this.vs = Array.from(this.querySelectorAll('[data-nachi-variant]'));
        this.cur = this.vs.find((b) => b.getAttribute('aria-pressed') == 'true');
        /* without chips (one model with a URL) the root carries the shown model's key, so its show_on still applies */
        this.key = (this.cur || this).getAttribute('data-nachi-key') || '';
        this.dt = q('[data-nachi-d]');
        this.se = q('[data-nachi-s]');
        this.num();
        this.sh = this.getAttribute('data-nachi-showing') || '';
        this.o0 = this.getAttribute('data-nachi-orbit-start') || '90deg 90deg';
        this.o1 = this.getAttribute('data-nachi-orbit-end') || '35deg 65deg';

        /* theme editor: the selected hotspot block's balloon pulses and its row lights until it is deselected (a part the
           shown model lacks first switches to a model that has it); a selected variant block shows its model */
        var pick = (set) => (e) => {
          var id = e.detail && e.detail.blockId;
          var el = id && this.querySelector('[data-nachi-block="' + id + '"]');
          if (!el) return;
          /* a hidden part or spec row first switches to a model that has it */
          var c = set && el.hidden && this.vs.find((x) => el.getAttribute('data-nachi-on').includes('|' + x.getAttribute('data-nachi-key') + '|'));
          if (c) this.use(c);
          if (!el.hasAttribute('data-nachi-row')) return set && !c && this.use(el);
          this.hot(el, set);
          mark(this.bOf(el), 'data-nachi-pulse', set);
        };
        document.addEventListener('shopify:block:select', pick(true), { signal: sg });
        document.addEventListener('shopify:block:deselect', pick(false), { signal: sg });

        if (!this.v || !this.st) return;
        this.state('booting');
        this.sync();
        if (this.pz) this.v.setAttribute('camera-orbit', this.o1 + ' auto');

        /* the stage shows the focus ring when the canvas is reached by keyboard (focus sits in model-viewer's shadow root) */
        var kb = false;
        document.addEventListener('keydown', () => { kb = true; }, { signal: sg, capture: true });
        document.addEventListener('pointerdown', () => { kb = false; }, { signal: sg, capture: true });
        on(this.v, {
          focusin: (e) => { if (e.target === this.v) mark(this.st, 'data-nachi-focus', kb); },
          focusout: (e) => { if (e.target === this.v) mark(this.st, 'data-nachi-focus', false); }
        }, sg);

        if (this.rb) this.rb.addEventListener('click', () => { if (this.pz) this.spin(); else this.halt(); }, { signal: sg });
        if (this.xb) this.xb.addEventListener('click', () => this.reset(), { signal: sg });

        if (!webgl()) {
          this.fail();
          return;
        }

        this.heads('BUTTON');
        this.bind(sg);
        this.bal();
        this.vs.forEach((b) => on(b, { click: () => this.use(b), pointerenter: () => this.pf(b), focus: () => this.pf(b) }, sg));

        /* motion #12: the library is requested within 150% of the viewport or on the first touch / key on the stage;
           under saveData the "Load the 3D model" button asks instead (#26) */
        var ask = () => this.ask();
        var conn = navigator.connection;
        if (conn && conn.saveData && this.lb) {
          this.lb.hidden = false;
          this.lb.addEventListener('click', () => {
            this.lb.classList.add('is-leaving');
            this.tick(() => { this.lb.hidden = true; }, 150);
            ask();
          }, { signal: sg });
          return;
        }
        on(this.st, { pointerdown: ask, keydown: ask }, sg);
        if ('IntersectionObserver' in window) {
          this.near = new IntersectionObserver((es) => {
            if (es.some((e) => e.isIntersecting)) ask();
          }, { rootMargin: '150% 0px' });
          this.near.observe(this.st);
        } else {
          this.tick(ask, 0);
        }
      }

      disconnectedCallback() {
        if (this.ac) this.ac.abort();
        if (this.io) this.io.disconnect();
        if (this.near) this.near.disconnect();
        /* tm, io and near are reset by connectedCallback; clearing a timer that already fired is harmless */
        this.tm.forEach(clearTimeout);
      }

      state(s) {
        this.setAttribute('data-nachi-state', s);
      }

      tick(fn, delay) {
        this.tm.push(setTimeout(() => {
          if (!this.sg.aborted) fn();
        }, delay));
      }

      say(text) {
        if (!this.lv) return;
        this.lv.textContent = '';
        requestAnimationFrame(() => {
          if (!this.sg.aborted) this.lv.textContent = text || '';
        });
      }

      /* ---- lifecycle: booting -> loading -> loaded -> revealed, or error ---- */

      ask() {
        if (this.ak) return;
        this.ak = true;
        /* the pressed chip is centred in the strip here, from the observer's callback (layout is already done) or an
           input, never during the script's own run where the read would force the page's first layout */
        if (this.cur) this.sv(this.cur);
        if (this.near) {
          this.near.disconnect();
          this.near = null;
        }
        this.state('loading');
        this.say(this.ln ? this.ln.textContent : '');
        loadLib().then(() => {
          if (!this.sg.aborted) this.init();
        }, () => {
          if (!this.sg.aborted) this.fail();
        });
      }

      init() {
        var v = this.v;
        /* our observer already gated the request, so the GLB fetch starts at once and the swing can be seen at 50% visible */
        v.setAttribute('loading', 'eager');
        on(v, {
          /* a load that a quicker second switch cancelled still fires load (for the old URL): only the current src counts */
          load: (e) => e.detail.url == v.src && this.got(),
          /* a GLB that fails keeps the chips, so another model (or the one before) can still be chosen */
          error: () => this.fail(1),
          /* dragging never fights the swing: user input before the swing reveals at once, without the snap (the view is
             not the settled one, so the first model's balloons keep their slider points); input while a snap is pending
             (waiting off screen, in its two frames or part way through its rays) cancels the rest of it the same way */
          'camera-change': (e) => {
            if (e.detail && e.detail.source === 'user-interaction') {
              this.pd = 0;
              if (!this.rv) {
                this.sw = true;
                this.reveal();
              }
            }
          }
        }, this.sg);
        this.watch();
        if (v.loaded) this.got();
      }

      /* one observer: leaving the viewport pauses the turntable (5.2 rule 4), the 50% mark starts the swing (#13) */
      watch() {
        if (!('IntersectionObserver' in window)) {
          this.iv = true;
          return;
        }
        /* off until the first report: model-viewer draws nothing off screen, so a snap before it would read stale rects */
        this.off = true;
        var h = this.st.getBoundingClientRect().height;
        var t = 0.5;
        if (h > 0 && window.innerHeight * 0.5 < h * 0.5) t = Math.max(0.1, Math.min(0.5, (window.innerHeight * 0.5) / h));
        this.io = new IntersectionObserver((es) => {
          es.forEach((e) => {
            this.off = !e.isIntersecting;
            this.classList.toggle('is-offscreen', this.off);
            if (this.off) {
              this.v.removeAttribute('auto-rotate');
              return;
            }
            this.go();
            if (this.rv && !this.pz) this.spin();
            if (e.intersectionRatio >= t - 0.01) {
              this.iv = true;
              this.swing();
            }
          });
        }, { threshold: [0, t] });
        this.io.observe(this.st);
      }

      /* every load: the chosen variant's balloons show again; a recovered error clears. A later model (a variant switch)
         keeps the camera's angles and the turntable (model-viewer keeps theta / phi across src changes), is framed again,
         and its balloons get their slider points and the deferred snap on every switch, however the first reveal went
         (only on screen, cancelled by input, each hit checked against the sliders); the edge-on swing belongs to the
         first model only */
      got() {
        var t = this.an ? (this.sh + ' ' + this.cur.textContent).trim() : '';
        this.an = 0;
        /* a model shown once stays in model-viewer's cache, so its chip never prefetches */
        if (this.cur) this.cur.pf = 1;
        mark(this, 'data-nachi-busy');
        this.bal();
        if (this.er) {
          this.er = 0;
          this.heads('BUTTON');
          if (this.fn) this.fn.hidden = true;
        }
        if (this.ld) {
          this.state(this.rv ? 'revealed' : 'loaded');
          this.frame();
          this.pd = 1;
          this.go();
          return this.say(t);
        }
        this.ld = true;
        this.state('loaded');
        this.say(t);
        this.frame();
        if (this.rm || this.ed) {
          this.sw = true;
          this.reveal(1);
          return;
        }
        /* load landed with the stage already in view: one beat edge-on, then the swing; otherwise the observer starts it */
        if (this.iv) this.tick(() => this.swing(), 400);
        else this.swing();
      }

      swing() {
        if (this.sw || !this.ld || !this.iv) return;
        this.sw = true;
        var v = this.v;
        var goal = orbit(this.o1);
        v.setAttribute('camera-orbit', this.orb(this.o1));
        /* the settled view (or, at the 1300ms cap, the camera put on it) is the one view the snap trusts; the cap may
           settle off screen (scrolled away mid-swing), so the reveal happens there but the snap waits for the stage (go) */
        var settle = () => {
          if (!this.rv) v.jumpCameraToGoal();
          this.reveal(1);
        };
        v.addEventListener('camera-change', (e) => {
          if (this.rv || !goal || !e.detail || e.detail.source !== 'none') return;
          var o = v.getCameraOrbit();
          if (dist(o.theta, goal.t) < 0.01 && dist(o.phi, goal.p) < 0.01) settle();
        }, { signal: this.sg });
        this.tick(settle, SWING_CAP);
      }

      /* s: the camera is on the settled view (swing settled, reduced motion, theme editor), so the face snap may run */
      reveal(s) {
        if (this.rv) return;
        this.rv = true;
        this.state('revealed');
        this.pd = s;
        this.go();
        if (!this.pz && !this.off) this.spin();
      }

      /* the pending snap runs only with the stage on screen: model-viewer renders nothing off screen, so the balloons'
         rects would be stale and every ray rejected. Reduced motion and the theme editor reveal at load, usually off
         screen (the library is asked within 150% of the viewport); the swing's cap can settle after the visitor scrolled
         away. The observer calls this again when the stage comes back; snap waits two frames, so model-viewer has drawn
         the settled view (the camera is already on it: jumpCameraToGoal at load or at the cap) before any ray is cast.
         pd stays set until the last ray: a visitor's input cancels the rest, leaving the screen pauses it (the next
         go() starts it again) and a newer snap (a later switch) replaces it. */
      go() {
        if (this.pd && !this.off) this.snap();
      }

      /* x: only this GLB failed (the viewer's error event); otherwise 3D cannot run at all and the chips go too */
      fail(x) {
        this.er = 1;
        mark(this, 'data-nachi-busy');
        mark(this, 'data-nachi-no3d', !x);
        this.heads('SPAN');
        this.state('error');
        if (this.fn) this.fn.hidden = false;
        this.say(this.fn ? this.fn.textContent : '');
      }

      /* ---- rotation and reset (7.4 controls) ---- */

      spin() {
        this.pz = false;
        if (this.rv && !this.off) {
          this.v.setAttribute('auto-rotate-delay', '0');
          this.v.setAttribute('rotation-per-second', '10deg');
          this.v.setAttribute('auto-rotate', '');
        }
        this.sync();
      }

      halt() {
        this.pz = true;
        this.v.removeAttribute('auto-rotate');
        this.sync();
      }

      /* the chip's name is fixed; aria-pressed (and the kit's black fill) carries the paused state, as the ticker's control (6.26) */
      sync() {
        if (this.rb) this.rb.setAttribute('aria-pressed', this.pz ? 'true' : 'false');
      }

      reset() {
        var v = this.v;
        v.setAttribute('camera-orbit', this.orb(this.o1));
        v.setAttribute('camera-target', 'auto auto auto');
        v.setAttribute('field-of-view', '30deg');
        v.resetTurntableRotation();
      }

      /* ---- model variants (merchant request 3) ---- */

      /* a chip (or its block selected in the editor) shows its model: the pressed state, the spec card, the alt and the
         parts list change at once (inside the input's layout-shift window); the stage dims while the GLB loads (got) */
      use(b) {
        var a = (k) => b.getAttribute('data-nachi-' + k);
        var u = a('variant');
        /* no switch once 3D cannot run at all (an editor block select would otherwise bring the loading note back) */
        if (!u || b === this.cur || this.hasAttribute('data-nachi-no3d')) return;
        this.cur = b;
        this.key = a('key');
        this.vs.forEach((x) => x.setAttribute('aria-pressed', x === b));
        this.sv(b);
        if (this.dt) this.dt.hidden = !(this.dt.textContent = a('des'));
        if (this.se) this.se.textContent = a('seals');
        this.rs.concat(this.sp).forEach((r) => { r.hidden = !this.ok(r); });
        this.num();
        this.an = 1;
        if (this.er) {
          if (this.fn) this.fn.hidden = true;
          this.state('loading');
        }
        mark(this, 'data-nachi-busy', this.ld);
        this.v.setAttribute('alt', a('alt'));
        this.v.setAttribute('src', u);
      }

      /* centre a chip in the scrolling strip below 750 (a no-op where the row wraps) */
      sv(b) {
        var g = b.parentNode;
        g.scrollLeft += b.getBoundingClientRect().left - g.getBoundingClientRect().left - (g.clientWidth - b.offsetWidth) / 2;
      }

      /* a hotspot shows when its show_on list is blank or names the shown model */
      ok(el) {
        var s = el.getAttribute('data-nachi-on');
        return !s || !this.key || s.includes('|' + this.key + '|');
      }

      /* the shown model's parts count 1, 2, 3 ... in the list and on the balloons, without the gaps of the parts it lacks */
      num() {
        var k = 0;
        this.rs.forEach((row) => {
          if (!this.ok(row)) return;
          k++;
          var s = row.querySelector('.nachi-model__part-num');
          var b = this.bOf(row);
          if (s) s.textContent = k;
          if (b) {
            b.textContent = k;
            b.setAttribute('aria-label', b.getAttribute('aria-label').replace(/\d+$/, k));
          }
        });
      }

      /* a hotspot the shown model lacks is hidden, not detached: model-viewer orders its hotspot slots by insertion, so a
         balloon put back would land after the others and break the focus order (WCAG 2.4.3); hidden it is out of the tab
         order and the accessibility tree */
      bal() {
        this.bs.forEach((b) => { b.hidden = !this.ok(b); });
      }

      /* pointing at or focusing a chip fetches its GLB at low priority into the HTTP cache, once, never under saveData */
      pf(b) {
        var c = navigator.connection;
        if (b.pf || b === this.cur || (c && c.saveData)) return;
        b.pf = 1;
        fetch(b.getAttribute('data-nachi-variant'), { priority: 'low' }).then((r) => r.blob()).catch(() => {});
      }

      /* ---- legend rows and balloons (6.19, 7.4): hover / focus highlights both, click / Enter flies the camera ---- */

      /* the row head is a span until the viewer is live, then a button; back to a span when 3D failed */
      heads(tag) {
        this.rs.forEach((row) => {
          var old = row.querySelector('[data-nachi-head]');
          if (!old || old.tagName === tag) return;
          var el = document.createElement(tag);
          if (tag === 'BUTTON') el.type = 'button';
          el.className = old.className;
          el.setAttribute('data-nachi-head', '');
          while (old.firstChild) el.appendChild(old.firstChild);
          old.replaceWith(el);
        });
      }

      bind(sg) {
        var hover = (row, click) => ({
          pointerenter: () => this.hot(row, true),
          pointerleave: () => this.hot(row, false),
          focusin: () => this.hot(row, true),
          focusout: () => this.hot(row, false),
          click: click
        });
        this.rs.forEach((row) => {
          on(row, hover(row, (e) => { if (e.target.closest('[data-nachi-head]')) this.fly(row); }), sg);
        });
        this.bs.forEach((b) => {
          var row = this.rowBy('data-nachi-row', b.getAttribute('data-nachi-balloon'));
          if (row) on(b, hover(row, () => this.fly(row)), sg);
        });
      }

      rowBy(attr, value) {
        return this.rs.find((row) => row.getAttribute(attr) === String(value)) || null;
      }

      bOf(row) {
        var n = row.getAttribute('data-nachi-row');
        return this.bs.find((b) => b.getAttribute('data-nachi-balloon') === n) || null;
      }

      hot(row, set) {
        mark(row, 'data-nachi-hot', set);
        mark(this.bOf(row), 'data-nachi-hot', set);
      }

      fly(row) {
        var v = this.v;
        if (!this.ld) return;
        var b = this.bOf(row);
        var target = row.getAttribute('data-nachi-target') || (b ? b.getAttribute('data-position') : '');
        var o = row.getAttribute('data-nachi-orbit');
        if (target) v.setAttribute('camera-target', target);
        if (o) v.setAttribute('camera-orbit', this.orb(o, 1));
      }

      /* ---- framing and hotspot placement (7.4 model_size, 6.19 sliders) ---- */

      /* "35deg 65deg" plus the framed distance; with rel a third value in % scales that distance (a hotspot's camera orbit) */
      orb(s, rel) {
        var p = String(s).trim().split(/\s+/);
        var k = rel && /%$/.test(p[2]) ? parseFloat(p[2]) / 100 : 1;
        return p[0] + ' ' + (p[1] || '75deg') + ' ' + (this.r ? this.r * k + 'm' : 'auto');
      }

      /* After load: the axis is the model's thinnest dimension (or the axis setting), the outside radius R the larger of the
         other two. At the fixed 30deg field of view the camera sits where the outside diameter spans model_size % of the
         stage height (the shorter side of the 1:1 and 4:3 stages), and the radius limits are set so it is never clamped.
         Then every slider balloon gets a point in metres around the bounding-box centre and its normal. */
      frame() {
        var v = this.v;
        if (typeof v.getDimensions !== 'function') return;
        var d = v.getDimensions();
        var c = v.getBoundingBoxCenter();
        var D = [d.x, d.y, d.z];
        var C = [c.x, c.y, c.z];
        var ax = 'xyz'.indexOf(this.getAttribute('data-nachi-axis') || '-');
        if (ax < 0) ax = D.indexOf(Math.min.apply(null, D));
        var u = ax === 2 ? 1 : 2;
        var w = 3 - ax - u;
        var R = Math.max(D[u], D[w]) / 2;
        var H = D[ax] / 2;
        var r = this.r = R / ((this.getAttribute('data-nachi-size') || 65) / 100 * Math.tan(Math.PI / 12));
        var o = v.getCameraOrbit();
        v.setAttribute('min-camera-orbit', 'auto auto ' + r * 0.4 + 'm');
        v.setAttribute('max-camera-orbit', 'auto auto ' + r + 'm');
        v.setAttribute('camera-orbit', o.theta + 'rad ' + o.phi + 'rad ' + r + 'm');
        v.jumpCameraToGoal();
        var bore = (this.getAttribute('data-nachi-bore') || 50) / 100;
        this.K = [C, ax, u, w, R, H];
        this.bs.forEach((b) => {
          var s = b.getAttribute('data-nachi-surface');
          if (!s) return;
          /* angle (deg, 0 = the side the camera sees at 0deg), across (% of half the width), distance (% of R) */
          var a = (b.getAttribute('data-nachi-at') || '0 0 75').split(' ').map(Number);
          var t = (a[0] * Math.PI) / 180;
          var f = s === 'front' ? 1 : s === 'back' ? -1 : 0;
          var g = f ? 0 : s === 'bore' ? -1 : 1;
          var q = f ? (R * a[2]) / 100 : g < 0 ? R * bore : R;
          var P = C.slice();
          var N = [0, 0, 0];
          P[u] += q * Math.cos(t);
          P[w] += q * Math.sin(t);
          P[ax] += f ? f * H : (H * a[1]) / 100;
          N[u] = g * Math.cos(t);
          N[w] = g * Math.sin(t);
          N[ax] = f;
          b.k = [f, q, t];
          this.put(b, P.map((x) => x + 'm').join(' '), N.join(' '));
        });
      }

      put(b, p, n) {
        b.setAttribute('data-position', p);
        b.setAttribute('data-normal', n);
        this.v.updateHotspot({ name: b.slot, position: p, normal: n });
      }

      /* a face point at the given distance may sit over the gap between the rings; once the camera has rendered the
         settled view, each face balloon moves onto the surface under it (ball, cage, groove or ring face). The first ray
         is the balloon's own screen point; when its hit disagrees with the sliders, rays step a quarter width at a time
         deeper along the axis (on screen), so the hit is the surface straight under the point or the lip in front of it.
         A hit counts only on the requested side of the axis, within 15 % of R of the distance and 20deg of the angle;
         otherwise the balloon keeps its computed point. A face the camera cannot see is never snapped. */
      snap() {
        var v = this.v;
        var g = this.sq = {};
        var i = 0;
        var j = 0;
        /* the rays are spread over frames, about 8 ms of them per frame (9.x: no long task from our script); each frame
           takes the camera and the balloon's rect afresh, as the turntable may have turned in between */
        var f = () => {
          var [C, ax, u, w, R, H] = this.K || [];
          if (this.sg.aborted || !C || !this.pd || this.sq !== g || this.off) return;
          var T = performance.now();
          var o = v.getCameraOrbit();
          var sp = Math.sin(o.phi);
          var cp = Math.cos(o.phi);
          /* the camera's angle around the model, less the turntable's turn (it matters after a model switch, once the
             turntable has run, for a bearing whose axis is not Y) */
          var y = o.theta - v.turntableRotation;
          var st = Math.sin(y);
          var ct = Math.cos(y);
          /* e: the camera's offset from the centre along the axis; k: a quarter width in px at the target */
          var e = o.radius * [sp * st, cp, sp * ct][ax];
          var k = (H * v.clientHeight) / (8 * o.radius * Math.tan(Math.PI / 12));
          var X = k * [ct, 0, -st][ax];
          var Y = k * [cp * st, -sp, cp * ct][ax];
          for (; i < this.bs.length; i += 1, j = 0) {
            var b = this.bs[i];
            var [s, q, t] = b.k || [];
            if (!s || b.hidden || s * e <= H) continue;
            var c = b.getBoundingClientRect();
            for (; j < 9; j += 1) {
              if (performance.now() - T > 8) return requestAnimationFrame(f);
              var hit = v.positionAndNormalFromPoint(c.left + c.width / 2 - s * j * X, c.top + c.height / 2 - s * j * Y);
              var p = hit && hit.position;
              var d = p && [p.x - C[0], p.y - C[1], p.z - C[2]];
              if (d && d[ax] * s > 0 && Math.abs(Math.hypot(d[u], d[w]) - q) < R * 0.15 && dist(Math.atan2(d[w], d[u]), t) < 0.35) {
                this.put(b, p.toString(), hit.normal.toString().replace(/m/g, ''));
                break;
              }
            }
          }
          this.pd = 0;
        };
        requestAnimationFrame(() => requestAnimationFrame(f));
      }
    }

    customElements.define('nachi-model', NachiModel);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nachi-nav"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('nachi-nav')) return;

    const REDUCED_MOTION = '(prefers-reduced-motion: reduce)';
    const OFFSET_PROPERTY = '--nachi-nav-offset';

    /**
     * Sticky in-page navigation with scroll-spy (DESIGN_SPEC_V2 6.20 / 7.2).
     * Progressive enhancement: the chips work as plain anchors without this; the ink row, the smooth scroll,
     * aria-current and the header offset are added here and removed in disconnectedCallback.
     */
    class NachiNav extends HTMLElement {
      connectedCallback() {
        this.abortController = new AbortController();
        const { signal } = this.abortController;

        this.ink = this.querySelector('.nachi-nav__ink');
        this.scroller = this.querySelector('.nachi-nav__scroller');
        this.links = Array.from(this.querySelectorAll('a.nachi-nav__link'));
        this.linkByTarget = new Map();
        this.targets = [];
        this.active = [];
        this.current = null;
        this.pending = null;
        this.observer = null;
        this.endObserver = null;
        this.last = null;
        this.endVisible = false;
        this.resizeTimer = 0;
        this.pendingTimer = 0;
        this.frame = 0;
        this.inkShown = false;
        this.inkAt = 0;
        this.manualOffset = Number.parseInt(this.dataset.nachiOffset || '0', 10) || 0;

        for (const link of this.links) {
          const id = this.targetId(link);
          if (id) this.linkByTarget.set(id, link);
        }

        this.classList.add('is-enhanced');
        this.applyOffset();
        this.observe();
        // the overflow flag needs the strip's layout: read it in a one-shot IntersectionObserver callback (after
        // the first layout, no forced layout inside the script task; 5.2 rule 6), which also covers a connect
        // after load, as in the theme editor
        if ('IntersectionObserver' in window) {
          const once = new IntersectionObserver(() => {
            once.disconnect();
            if (!signal.aborted) this.refresh();
          });
          once.observe(this);
        }

        this.addEventListener('click', (event) => this.onClick(event), { signal });
        // keyboard focus: Chromium leaves a partially clipped chip where it is, so Tab into a chip that straddles
        // the strip's edge would focus it under the fade; scroll the strip (never the window) to show it whole
        this.addEventListener('focusin', (event) => this.onFocusIn(event), { signal });
        window.addEventListener('resize', () => this.onResize(), { signal });
        window.addEventListener('load', () => this.refresh(), { signal, once: true });
        // the theme editor re-renders sibling sections in place, so their anchors must be observed again
        document.addEventListener('shopify:section:load', () => this.observe(), { signal });
        if (document.fonts && document.fonts.ready) {
          // the swap from the fallback family changes the chip widths, so the ink and the overflow flag are re-read
          document.fonts.ready.then(() => {
            if (!signal.aborted) this.refresh();
          });
        }
      }

      disconnectedCallback() {
        if (this.abortController) this.abortController.abort();
        if (this.observer) this.observer.disconnect();
        if (this.endObserver) this.endObserver.disconnect();
        window.clearTimeout(this.resizeTimer);
        window.clearTimeout(this.pendingTimer);
        window.cancelAnimationFrame(this.frame);
        this.observer = null;
        this.endObserver = null;
        this.last = null;
        this.endVisible = false;
        this.active = [];
        this.current = null;
        this.pending = null;
        this.classList.remove('is-enhanced', 'is-overflowing');
        document.documentElement.style.removeProperty(OFFSET_PROPERTY);
      }

      /** @returns {boolean} */
      reducedMotion() {
        return window.matchMedia(REDUCED_MOTION).matches;
      }

      /**
       * @param {HTMLAnchorElement} link
       * @returns {string} the fragment the link points at, decoded, or an empty string
       */
      targetId(link) {
        const href = link.getAttribute('href') || '';
        if (href.charAt(0) !== '#' || href.length < 2) return '';
        try {
          return decodeURIComponent(href.slice(1));
        } catch (error) {
          return href.slice(1);
        }
      }

      /**
       * 7.2 header offset: the manual range wins; at 0 the first header / banner that is sticky or fixed
       * (itself or through a sticky ancestor such as Dawn's section wrapper) supplies its bottom edge.
       * The result goes on the document root because sibling sections read it for their scroll margin.
       */
      measureOffset() {
        if (this.manualOffset > 0) return this.manualOffset;
        const headers = document.querySelectorAll('header, [role="banner"]');
        for (const header of headers) {
          if (this.contains(header)) continue;
          let node = header;
          while (node && node !== document.body) {
            const position = window.getComputedStyle(node).position;
            if (position === 'sticky' || position === 'fixed') {
              const bottom = node.getBoundingClientRect().bottom;
              return Math.max(0, Math.round(bottom));
            }
            node = node.parentElement;
          }
        }
        return 0;
      }

      applyOffset() {
        const offset = this.measureOffset();
        document.documentElement.style.setProperty(OFFSET_PROPERTY, `${offset}px`);
      }

      onResize() {
        window.clearTimeout(this.resizeTimer);
        this.resizeTimer = window.setTimeout(() => this.refresh(), 150);
      }

      /** first layout, load, fonts, debounced resize: the header offset, the overflow flag and the ink; the two
          reads come before the two writes so there is one layout, not two */
      refresh() {
        const offset = this.measureOffset();
        const scroller = this.scroller;
        const overflowing = Boolean(scroller) && scroller.scrollWidth > scroller.clientWidth;
        document.documentElement.style.setProperty(OFFSET_PROPERTY, `${offset}px`);
        this.classList.toggle('is-overflowing', overflowing);
        this.placeInk(false);
      }

      /** 7.2 scroll-spy: observe every target in a band between 40% and 45% of the viewport. */
      observe() {
        if (this.observer) this.observer.disconnect();
        if (this.endObserver) this.endObserver.disconnect();
        this.targets = [];
        this.last = null;
        this.endVisible = false;
        for (const id of this.linkByTarget.keys()) {
          const target = document.getElementById(id);
          if (!target) continue;
          this.targets.push(target);
          if (!this.last || this.last.compareDocumentPosition(target) & Node.DOCUMENT_POSITION_FOLLOWING) this.last = target;
        }
        this.active = [];
        if (!('IntersectionObserver' in window) || this.targets.length === 0) return;

        this.observer = new IntersectionObserver((entries) => this.onIntersect(entries), {
          rootMargin: '-40% 0px -55% 0px',
          threshold: 0,
        });
        for (const target of this.targets) this.observer.observe(target);
        // the page end: a last section shorter than the space below the band never reaches it (tall screens, a
        // short footer), so once it is wholly on screen it counts as reached; one observer, no scroll listener
        this.endObserver = new IntersectionObserver(
          (entries) => {
            for (const entry of entries) this.endVisible = entry.intersectionRatio >= 0.98;
            this.syncCurrent();
          },
          { threshold: [0, 0.98, 1] }
        );
        this.endObserver.observe(this.last);
      }

      /** @param {IntersectionObserverEntry[]} entries */
      onIntersect(entries) {
        for (const entry of entries) {
          const index = this.active.indexOf(entry.target);
          if (index >= 0) this.active.splice(index, 1);
          if (entry.isIntersecting) this.active.push(entry.target);
        }
        this.syncCurrent();
      }

      /**
       * The current section from the band's contents. While a chip click's smooth scroll is in flight the spy
       * holds on the clicked target (the pill moves once, to the chosen chip, instead of hopping through every
       * section the scroll passes); the hold ends when that target enters the band, or after 1.5s. The last
       * section, wholly on screen, wins over the band (it may never reach the band: see observe).
       */
      syncCurrent() {
        const atEnd = Boolean(this.last) && this.endVisible;
        if (this.pending) {
          if (!this.active.includes(this.pending) && !(atEnd && this.pending === this.last)) return;
          // arrived: the clicked target is already current and stays so until the next band change
          this.clearPending();
          return;
        }
        if (atEnd) {
          this.setCurrent(this.last);
          return;
        }
        if (this.active.length > 0) {
          this.setCurrent(this.active[this.active.length - 1]);
          return;
        }
        // nothing in the band: above the first target there is no current section; between targets the
        // most recent one stays current
        const first = this.targets[0];
        if (first && first.getBoundingClientRect().top > window.innerHeight * 0.45) this.setCurrent(null);
      }

      /** @param {Element} target */
      holdOn(target) {
        this.pending = target;
        window.clearTimeout(this.pendingTimer);
        this.pendingTimer = window.setTimeout(() => {
          this.pending = null;
          this.syncCurrent();
        }, 1500);
      }

      clearPending() {
        window.clearTimeout(this.pendingTimer);
        this.pending = null;
      }

      /** @param {Element | null} target */
      setCurrent(target) {
        if (target === this.current) return;
        this.current = target;
        const link = target ? this.linkByTarget.get(target.id) : null;
        for (const other of this.links) {
          if (other === link) other.setAttribute('aria-current', 'location');
          else other.removeAttribute('aria-current');
        }
        this.placeInk(true);
        if (link) this.revealLink(link);
        // back above the first section: the strip returns to its start so the first chips show again
        else if (this.scroller && this.scroller.scrollLeft !== 0) {
          this.scroller.scrollTo({ left: 0, behavior: this.reducedMotion() ? 'auto' : 'smooth' });
        }
      }

      /**
       * 6.20 ink row: one layout read of the current chip's box (inside the track, its offset parent; offsetLeft
       * is physical, as the clip-path insets are), then the two custom properties are written in a frame. With
       * no current section the pill collapses in place; a pill that was not visible jumps instead of sliding.
       * @param {boolean} animate false for layout-driven moves (resize, fonts) so the pill never slides
       */
      placeInk(animate) {
        const ink = this.ink;
        if (!ink) return;
        const link = this.current ? this.linkByTarget.get(this.current.id) : null;
        let start = this.inkAt;
        let end = this.inkAt;
        if (link) {
          start = link.offsetLeft;
          end = start + link.offsetWidth;
        }
        const jump = !animate || !this.inkShown;
        this.inkShown = Boolean(link);
        this.inkAt = start;
        window.cancelAnimationFrame(this.frame);
        this.frame = window.requestAnimationFrame(() => {
          if (jump) ink.classList.add('is-jump');
          ink.style.setProperty('--nachi-ink-l', `${start}px`);
          ink.style.setProperty('--nachi-ink-r', `calc(100% - ${end}px)`);
          if (jump) {
            void ink.offsetWidth;
            ink.classList.remove('is-jump');
          }
        });
      }

      /**
       * 5.3 #8 mobile strip: bring the current chip into view by scrolling the strip. The strip itself is
       * scrolled (scrollBy on the scroller, never scrollIntoView), so the window is never in the scroll chain:
       * a window move here would cancel a chip click's smooth scroll and shift the scroll-spy band.
       * @param {HTMLElement} link
       */
      revealLink(link) {
        this.scrollStripTo(link, this.reducedMotion() ? 'auto' : 'smooth');
      }

      /**
       * Nearest-edge scroll of the strip to show a chip whole, with the scroller's scroll padding (24px, the
       * fade) kept clear on the side it arrives at. Physical deltas from the two boxes, so it holds in RTL too.
       * Chips already fully inside the strip are left alone.
       * @param {HTMLElement} link
       * @param {ScrollBehavior} behavior
       */
      scrollStripTo(link, behavior) {
        const scroller = this.scroller;
        if (!scroller || scroller.scrollWidth <= scroller.clientWidth) return;
        const pad = Number.parseFloat(window.getComputedStyle(scroller).scrollPaddingInlineStart) || 0;
        const ring = 4; // outline-offset 2px + 2px ring
        const box = link.getBoundingClientRect();
        const view = scroller.getBoundingClientRect();
        let left = 0;
        if (box.left - ring < view.left) left = box.left - pad - view.left;
        else if (box.right + ring > view.right) left = box.right + pad - view.right;
        if (left !== 0) scroller.scrollBy({ left, behavior });
      }

      /**
       * 2.4.7 / 2.4.11 focus never obscured: a focused chip that straddles the strip's edge (ring included) is
       * scrolled into the strip; only the strip moves, the window stays still. Keyboard focus only: a pointer
       * press focuses the anchor on mousedown, and scrolling the strip then would move the chip out from under
       * the pointer before mouseup, so the click never fires on it; pointer focus does not match :focus-visible.
       * @param {FocusEvent} event
       */
      onFocusIn(event) {
        const link = event.target instanceof Element ? event.target.closest('.nachi-nav__link') : null;
        if (!link || !this.contains(link)) return;
        if (!link.matches(':focus-visible')) return;
        this.scrollStripTo(link, 'auto');
      }

      /**
       * 5.3 #9 chip click: smooth scroll by JS (never scroll-behavior on html), the URL keeps the fragment,
       * focus moves to the target so keyboard users continue from the section they chose.
       * @param {MouseEvent} event
       */
      onClick(event) {
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const link = event.target instanceof Element ? event.target.closest('a.nachi-nav__link') : null;
        if (!link || !this.contains(link)) return;
        const id = this.targetId(link);
        const target = id ? document.getElementById(id) : null;
        if (!target) return;

        event.preventDefault();
        const behavior = this.reducedMotion() ? 'auto' : 'smooth';
        if (window.history && window.history.pushState) {
          window.history.pushState(null, '', `#${encodeURIComponent(id)}`);
        }
        target.scrollIntoView({ behavior, block: 'start' });
        if (this.linkByTarget.has(id)) {
          this.holdOn(target);
          this.setCurrent(target);
        }
        if (!target.hasAttribute('tabindex')) {
          // the section is a focus destination, not a control: without this the keyboard-driven focus draws the
          // browser's ring around the whole section until the next blur
          target.setAttribute('tabindex', '-1');
          target.style.outline = 'none';
          target.addEventListener(
            'blur',
            () => {
              target.removeAttribute('tabindex');
              target.style.removeProperty('outline');
            },
            { once: true }
          );
        }
        target.focus({ preventScroll: true });
      }
    }

    customElements.define('nachi-nav', NachiNav);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            const recommendationCount = recommendations
              ? Number(recommendations.dataset.recommendationsCount || 0)
              : 0;
            if (
              recommendations &&
              recommendationCount > 0 &&
              recommendations.querySelector('.product-recommendations__product')
            ) {
              this.innerHTML = recommendations.innerHTML;
            }

            /* Color swatches */
            const generateSrcset = (image, widths = []) => {
              const imageUrl = new URL(image['src']);
              return widths
                .filter((width) => width <= image['width'])
                .map((width) => {
                  imageUrl.searchParams.set('width', width.toString());
                  return `${imageUrl.href} ${width}w`;
                })
                .join(', ');
            };

            const createImageElement = (image, classes, sizes, productTitle) => {
              const previewImage = image['preview_image'];
              const newImage = new Image(previewImage['width'], previewImage['height']);
              newImage.className = classes;
              newImage.alt = image['alt'] || productTitle;
              newImage.sizes = sizes;
              newImage.src = previewImage['src'];
              newImage.srcset = generateSrcset(previewImage, [165, 360, 533, 720, 940, 1066]);
              newImage.loading = 'lazy';
              return newImage;
            };

            const checkSwatches = () => {
              document.querySelectorAll('.js-color-swatches-wrapper').forEach(wrapper => {
                wrapper.querySelectorAll('.js-color-swatches input').forEach(input => {
                  input.addEventListener('click', (event) => {
                    const primaryImage = wrapper.querySelector(".media--first");
                    const secondaryImage = wrapper.querySelector(".media--second");
                    const handleProduct = wrapper.dataset.product;
                    
                    if (event.currentTarget.checked && primaryImage) {
                      wrapper.querySelector('.js-color-swatches-link').setAttribute('href', event.currentTarget.dataset.variantLink);
                      if (wrapper.querySelector('.card__add-to-cart button[name="add"]')) {
                        wrapper.querySelector('.card__add-to-cart button[name="add"]').setAttribute('aria-disabled', false);
                        wrapper.querySelector('.card__add-to-cart button[name="add"] > span').classList.remove('hidden');
                        wrapper.querySelector('.card__add-to-cart button[name="add"] .sold-out-message').classList.add('hidden');
                        wrapper.querySelector('.card__add-to-cart input[name="id"]').value = event.currentTarget.dataset.variantId;
                      }
                      
                      const currentColor = event.currentTarget.value;

                      jQuery.getJSON(window.Shopify.routes.root + `products/${handleProduct}.js`, function(product) {
                        const variant = product.variants.filter(item => item.featured_media != null && item.options.includes(currentColor))[0];

                        if (variant) {
                          const newPrimaryImage = createImageElement(variant["featured_media"], primaryImage.className, primaryImage.sizes, product.title);
                          
                          if (newPrimaryImage.src !== primaryImage.src) {
                            let flag = false;
                            if (secondaryImage) {
                              const secondaryImagePathname = new URL(secondaryImage.src).pathname;
                              const newPrimaryImagePathname = new URL(newPrimaryImage.src).pathname;

                              if (secondaryImagePathname == newPrimaryImagePathname) {
                                primaryImage.remove();
                                secondaryImage.classList.remove('media--second');
                                secondaryImage.classList.add('media--first');
                                flag = true;
                              } 
                            }
                            if (flag == false) {
                              primaryImage.animate({ opacity: [1, 0] }, { duration: 200, easing: "ease-in", fill: "forwards" }).finished;
                              setTimeout(function(){
                                primaryImage.replaceWith(newPrimaryImage);
                                newPrimaryImage.animate({ opacity: [0, 1] }, { duration: 200, easing: "ease-in" });
                                if (secondaryImage) {
                                  secondaryImage.remove();                                    
                                }
                              }, 200);
                            }
                          }
                        }
                      });
                    }
                  })
                })
              })
            }

            checkSwatches();
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), {
        rootMargin: '0px 0px 200px 0px',
      }).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sealmaster-food-beverage-solution"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sealmaster-stat-counter')) {
    class SealmasterStatCounter extends HTMLElement {
      connectedCallback() {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        this.display = this.querySelector('[data-counter-display]');
        this.finalText = this.dataset.value || '';
        this.target = Number(this.finalText.replace(/[^0-9.-]/g, ''));

        if (!this.display || Number.isNaN(this.target)) return;

        this.observer = new IntersectionObserver((entries) => {
          for (const entry of entries) {
            if (entry.isIntersecting) {
              this.#animate();
              this.observer.disconnect();
            }
          }
        }, { threshold: 0.4 });

        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      #animate() {
        const duration = 1200;
        const start = performance.now();

        const step = (now) => {
          const progress = Math.min((now - start) / duration, 1);
          const eased = 1 - Math.pow(1 - progress, 3);
          const current = Math.round(this.target * eased);
          this.display.textContent = current.toLocaleString();

          if (progress < 1) {
            requestAnimationFrame(step);
          } else {
            this.display.textContent = this.finalText;
          }
        };

        requestAnimationFrame(step);
      }
    }

    customElements.define('sealmaster-stat-counter', SealmasterStatCounter);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skf-bearings-overview"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('skf-stat-counter')) {
    class SkfStatCounter extends HTMLElement {
      connectedCallback() {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        this.display = this.querySelector('[data-counter-display]');
        this.finalText = this.dataset.value || '';
        this.target = Number(this.finalText.replace(/[^0-9.-]/g, ''));

        if (!this.display || Number.isNaN(this.target)) return;

        this.observer = new IntersectionObserver((entries) => {
          for (const entry of entries) {
            if (entry.isIntersecting) {
              this.#animate();
              this.observer.disconnect();
            }
          }
        }, { threshold: 0.4 });

        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      #animate() {
        const duration = 1200;
        const start = performance.now();

        const step = (now) => {
          const progress = Math.min((now - start) / duration, 1);
          const eased = 1 - Math.pow(1 - progress, 3);
          const current = Math.round(this.target * eased);
          this.display.textContent = current.toLocaleString();

          if (progress < 1) {
            requestAnimationFrame(step);
          } else {
            this.display.textContent = this.finalText;
          }
        };

        requestAnimationFrame(step);
      }
    }

    customElements.define('skf-stat-counter', SkfStatCounter);
  }

  } catch(e) { console.error(e); }
})();
})();
